module.exports = __webpack_public_path__ + "img/favicon.bce1a49.png";